import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    reference:
      typeof search.reference === "string"
        ? search.reference
        : typeof search.trxref === "string"
          ? search.trxref
          : undefined,
    youtube: typeof search.youtube === "string" ? search.youtube : undefined,
    reason: typeof search.reason === "string" ? search.reason : undefined,
    created: typeof search.created === "string" ? search.created : undefined,
    updated: typeof search.updated === "string" ? search.updated : undefined,
  }),
  component: DashboardLayout,
});

function DashboardLayout() {
  return <Outlet />;
}
